import { Node } from 'reactflow';
import { NodesTypes } from '@constants/canvas/general';
import { NodeDTOTypes } from '@store/services/nodes/types';
import { traverseNodes } from '@views/Insights/Stage/helpers';

/**
 * Builds set of focusedIds based on parent and childrenIds
 */
export const getFocusedNodeIds = (
  nodes: Node[],
  sourceId: string,
): string[] => {
  const focusedIds = new Set<string>(
    nodes.reduce<string[]>((acc, node) => {
      if (node.type !== NodesTypes.CustomNode) acc.push(node.id);

      return acc;
    }, []),
  );

  traverseNodes(nodes, focusedIds, sourceId, true, true, true);

  return Array.from(focusedIds);
};

/**
 * Eligible if not an Asset,has at least one relationship, no active multi select
 */
export const isFocusEligible = (
  node: Node,
  multiSelectionCount: number,
): boolean => {
  const dto = node.data?.dto;
  if (!dto) return false;

  const hasRelationship =
    (dto.parentsIds?.length ?? 0) > 0 || (dto.childrenIds?.length ?? 0) > 0;

  return (
    dto.type !== NodeDTOTypes.Asset &&
    hasRelationship &&
    multiSelectionCount < 2
  );
};
